import { HttpBackend, HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { Observable, of } from "rxjs";
import { catchError, map, tap } from "rxjs/operators";

@Injectable({
  providedIn: 'root',
})
export class DownLoadFileService {

  private noAuthHttp: HttpClient;

  constructor(
    private translate: TranslateService,
    private handler: HttpBackend,
    private toastrService: ToastrService,
  ) {
    this.noAuthHttp = new HttpClient(handler);
  }

  downloadFile(url: string, fileName: string, mimeType = 'default', download = true): Observable<any> {
    return this.noAuthHttp.get(url, { observe: 'response', responseType: 'blob' }).pipe(
      // Extracts file name.
      map(res => {
        // The Cors setting on api must expose this header.
        const disposition = res.headers.get('Content-Disposition') || '';
        const matches = /filename=([^;]+)/ig.exec(disposition) || [];
        const name = (matches[1] || fileName).trim().replace(/['"]+/g, '');
        return { res, name };
      }),
      map(({ res, name }) =>
        ({ data: new Blob([res.body], { type: mimeType === 'default' ? res.headers.get('Content-Type') : mimeType }), name })),
      tap(file => {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(file.data);

        if (download) {
          link.download = file.name;
        }
        link.setAttribute('target', '_blank');
        link.click();

        window.URL.revokeObjectURL(link.href);
      }),
      catchError(err => this.showError(this.translate.instant('error.file.title'), this.translate.instant('error.file.message'))),
    );
  }

  private showError(title: string, message: string): Observable<any> {
    this.toastrService.error(
      message,
      title,
      {
        closeButton: true,
        timeOut: 4000,
        onActivateTick: true,
      },
    );
    return of();
  }
}